import React, { useState, cloneElement, lazy } from 'react';
import { TrendingUpIcon, UsersIcon, ShieldCheckIcon, TrophyIcon } from 'lucide-react';
import { ImageData } from '../utils/mockData';
import { motion } from 'framer-motion';
import { DemographicCharts } from './DemographicCharts';
import { ImagePerformanceTable } from './ImagePerformanceTable';
interface MetricsOverviewProps {
  data: ImageData[];
}
export const MetricsOverview: React.FC<MetricsOverviewProps> = ({
  data
}) => {
  return <div className="space-y-8" data-id="element-289">
      <div className="bg-white p-6 rounded-sm shadow-[0_2px_8px_rgba(0,0,0,0.05)] border border-[#E5E5E5]" data-id="element-290">
        <h3 className="text-xl font-semibold text-[#101010]" data-id="element-291">
          The same creatives produced significantly different rankings per
          audience segment.
        </h3>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-292">
        {/* Tech Enthusiast Segment */}
        <div className="space-y-4" data-id="element-293">
          <div className="flex items-center justify-between mb-4" data-id="element-294">
            <h2 className="text-lg font-medium text-[#101010]" data-id="element-295">
              Asset Performance · Tech enthusiast audience
            </h2>
          </div>
          <div className="flex items-center bg-[#C00000] text-white px-3 py-1.5 rounded-sm shadow-sm self-start w-max mb-4" data-id="element-296">
            <TrophyIcon className="h-4 w-4 mr-1.5" data-id="element-297" />
            <span className="text-xs font-bold uppercase tracking-wide" data-id="element-298">
              WINNER: ASSET C · PRODUCT 1
            </span>
          </div>
          <ImagePerformanceTable data={data} segment="techEnthusiast" data-id="element-299" />
        </div>

        {/* Lifestyle Segment */}
        <div className="space-y-4" data-id="element-300">
          <div className="flex items-center justify-between mb-4" data-id="element-301">
            <h2 className="text-lg font-medium text-[#101010]" data-id="element-302">
              Asset Performance · Lifestyle audience
            </h2>
          </div>
          <div className="flex items-center bg-[#C00000] text-white px-3 py-1.5 rounded-sm shadow-sm self-start w-max mb-4" data-id="element-303">
            <TrophyIcon className="h-4 w-4 mr-1.5" data-id="element-304" />
            <span className="text-xs font-bold uppercase tracking-wide" data-id="element-305">
              WINNER: ASSET A · LIFESTYLE 1
            </span>
          </div>
          <ImagePerformanceTable data={data} segment="lifestyle" data-id="element-306" />
        </div>
      </div>

      {/* Cross-Segment Delta */}
      <div className="bg-white p-6 rounded-sm shadow-[0_2px_8px_rgba(0,0,0,0.05)] border border-[#E5E5E5]" data-id="element-307">
        <h3 className="text-lg font-medium text-[#101010] mb-6" data-id="element-308">
          Cross-Segment Delta
        </h3>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6" data-id="element-309">
          <div className="p-4 bg-[#F9FAFB] border border-[#E5E5E5] rounded-sm text-center" data-id="element-310">
            <p className="text-sm text-[#737373] mb-1" data-id="element-311">Asset A</p>
            <p className="text-2xl font-bold text-[#C00000]" data-id="element-312">-36</p>
            <p className="text-xs text-[#404040]" data-id="element-313">
              SPR 74 (lifestyle) → 38 (tech enthusiast)
            </p>
          </div>
          <div className="p-4 bg-[#F9FAFB] border border-[#E5E5E5] rounded-sm text-center" data-id="element-314">
            <p className="text-sm text-[#737373] mb-1" data-id="element-315">Asset B</p>
            <p className="text-2xl font-bold text-[#C00000]" data-id="element-316">-25</p>
            <p className="text-xs text-[#404040]" data-id="element-317">
              SPR 66 (lifestyle) → 41 (tech enthusiast)
            </p>
          </div>
          <div className="p-4 bg-[#F9FAFB] border border-[#E5E5E5] rounded-sm text-center" data-id="element-318">
            <p className="text-sm text-[#737373] mb-1" data-id="element-319">Asset C</p>
            <p className="text-2xl font-bold text-[#C00000]" data-id="element-320">+27</p>
            <p className="text-xs text-[#404040]" data-id="element-321">
              SPR 52 (lifestyle) → 79 (tech enthusiast)
            </p>
          </div>
          <div className="p-4 bg-[#F9FAFB] border border-[#E5E5E5] rounded-sm text-center" data-id="element-322">
            <p className="text-sm text-[#737373] mb-1" data-id="element-323">Asset D</p>
            <p className="text-2xl font-bold text-[#C00000]" data-id="element-324">+14</p>
            <p className="text-xs text-[#404040]" data-id="element-325">
              SPR 57 (lifestyle) → 71 (tech enthusiast)
            </p>
          </div>
        </div>
        <p className="text-base text-[#404040] leading-relaxed italic" data-id="element-326">
          Insight: Lifestyle-led creative ranks first within the lifestyle
          segment but falls to the bottom of the ranking within the tech
          enthusiast segment. Product-led creative wins decisively within the
          tech enthusiast segment while holding a mid-table position within the
          lifestyle segment.
        </p>
      </div>
    </div>;
};